import { observer } from 'mobx-react-lite'
import { useLocation } from 'react-router'
import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout } from 'entities/ExportRouters'
import { TextEnableLandlineRoutes } from 'pages/settings/pages/numbers/pages/TextEnableLandline/route/type'
import { NumbersPath } from 'pages/settings/pages/numbers/route/numbersPath'

export const TextEnableLandlineAccessLayout = observer(() => {
  const { pathname, search } = useLocation()

  return (
    <AccessLayout
      name={EnumAccessPageKeys.numbers_settings_add_landline}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          method: 'replace',
          path: `${NumbersPath.root}`,
        })
      }}
      onAccessSuccess={() => {
        if (!pathname.includes(TextEnableLandlineRoutes.enterNumber)) {
          uiStore.changeRouteViaVue({
            method: 'replace',
            path: `${NumbersPath.textEnableLandline.stepsRoot}`,
            query: search,
          })
        }
      }}
    />
  )
})
